import { useEffect } from "react";
import { useTranslation } from "react-i18next";
import StatusRequest from "../../../components/Cac/Customer/Request/StatusRequest";
import CustomerMissionTable from "../../../components/Cac/Customer/Mission/CustomerMissionTable";
import { useCustomerMissionStore } from "../../../stores/Cac/Customer/customerMission";
import { getMissions } from "../../../services/Api/customerService";
import { useParams } from "react-router-dom";
import SideBar from "../../../components/Layout/SideBar";
import Header from "../../../components/Layout/Header";
import Footer from "../../../components/Layout/Footer";
import { showToastError } from "../../../services/Toasts/toasts";

const CustomerHome = () => {
  const { t } = useTranslation();
  const { missionsClient, setMissionsClient } = useCustomerMissionStore();
  // Hooks
  const { idCustomer } = useParams();

  useEffect(() => {
    getMissions(Number(idCustomer))
      .then((data) => setMissionsClient(data?.missions))
      .catch(() => showToastError(t("common.error")));
  }, []);

  return (
    <div className="flex h-dvh w-full flex-col overflow-hidden bg-gradient-to-br from-slate-50 to-blue-50">
      <Header />
      <div className="flex min-h-0 flex-1 overflow-hidden">
        <SideBar />
        <main className="flex min-h-0 flex-1 flex-col overflow-y-auto pb-16 pt-3 sm:pl-14 md:pb-20">
          <div className="mx-auto flex min-h-0 w-full max-w-7xl flex-1 flex-col gap-3 px-3 lg:px-4 2xl:max-w-[2400px]">
          <section className="w-full flex-shrink-0 rounded-2xl border border-gray-200 bg-white p-4 shadow-sm sm:p-5 lg:p-6">
            <div className="flex flex-col items-start justify-between gap-4 lg:flex-row lg:items-center">
              
              {/* Titre principal */}
              <div className="flex min-w-0 items-center gap-3 sm:gap-4">
                <div className="hidden md:flex flex-shrink-0 rounded-xl bg-yellow-trio p-2.5 sm:p-3">
                  <svg className="h-5 w-5 text-grey-trio sm:h-6 sm:w-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z" />
                  </svg>
                </div>
                <div>
                  <h1 className="font-K2D text-lg font-bold text-gray-700 sm:text-xl">
                    {t("customerHome.missionsTitle")} <span className="text-yellow-trio">({missionsClient?.length}) </span>
                  </h1>
                  <p className="mt-1 text-sm text-gray-600 sm:text-base">
                    {t("customerHome.missionsSubtitle")}
                  </p>
                </div>
              </div>
              
              {/* Composant StatusRequest */}
              <div className="w-full lg:w-auto">
                <StatusRequest />
              </div>
            </div>
          </section>

          {/* Container principal pour la table */}
          <section className="min-h-[24rem] w-full flex-1 overflow-hidden rounded-2xl border border-gray-200 bg-white shadow-sm">
            <CustomerMissionTable />
          </section>
          </div>
        </main>
      </div>
      <Footer />
    </div>
  );
};

export default CustomerHome;
